import { render } from "./ClassEditView.vue?vue&type=template&id=d828bfb8"
import script from "./ClassEditView.vue?vue&type=script&lang=js"
export * from "./ClassEditView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__